import { render } from "./HomeDefault.vue?vue&type=template&id=df2a9cf6&scoped=true"
import script from "./HomeDefault.vue?vue&type=script&lang=js"
export * from "./HomeDefault.vue?vue&type=script&lang=js"

import "./HomeDefault.vue?vue&type=style&index=0&id=df2a9cf6&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2a9cf6"]])

export default __exports__